import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { zObjectId } from "@dobrh-monorepo/core";

const requestSchema = z.object({
  postedFor: zObjectId(),
  rating: z
    .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)])
    .refine((value) => [1, 2, 3, 4, 5].includes(value), {
      message: "Input must be one of 1, 2, 3, 4, or 5", // needed to override vague error message
    }),
  reviewText: z.string().min(1).max(500),
  serviceProjectId: zObjectId(),
});

export default {
  method: HttpMethodEnum.POST,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: z.object({}),
} satisfies Route;
